export default "__VITE_ASSET__CmqozhNF__"